import React from 'react';
import { TextField, IconButton } from '@mui/material';
import GTranslateIcon from '@mui/icons-material/GTranslate';
import {translateText} from "../service/deepl/DeeplService";

const getOppositeLang = (lang) => (lang === 'de' ? 'en' : 'de');

const TranslatableField = ({
                             label,
                             lang,
                             value,
                             otherLangValue,
                             onChange,
                             sx,
                             multiline = false,
                             rows = 1,
                           }) => {
  const shouldShowTranslate =
    !value && !!otherLangValue;

  const handleTranslate = async () => {
    const translated = await translateText(otherLangValue, lang, getOppositeLang(lang));
    onChange(translated);
  };

  return (
    <TextField
      fullWidth
      margin="normal"
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      multiline={multiline}
      rows={rows}
      sx={sx}
      InputProps={{
        endAdornment: shouldShowTranslate && (
          <IconButton size="small" onClick={handleTranslate}>
            <GTranslateIcon fontSize="small" />
          </IconButton>
        ),
      }}
    />
  );
};

export default TranslatableField;
